import axios from "../config/axios";

const API_BASE = "/agent-directory";

const agentDirectoryService = {
  search: (params = {}) => axios.get(`${API_BASE}/search`, { params }),
  getByLocation: (params = {}) => axios.get(`${API_BASE}/by-location`, { params }),
  getMyProfile: () => axios.get(`${API_BASE}/my-profile`),
  updateMyProfile: (data) => axios.put(`${API_BASE}/my-profile`, data),
};

export default agentDirectoryService;
